export enum RechercheColonneEnum {
  DISPOSITIF_NAME = 'dispositifName',
  SIRET = 'siret',
  NUMERO_DOSSIER = 'numeroDossier',
  LIBELLE_FORMATION = 'libelleFormation',
  DATE_DEBUT = 'dateDebut',
  STATUT = 'statut',
  DATE_DECISION = 'dateDecision',
  DATE_CREATION = 'dateCreation',
  MONTANT_ENGAGE = 'montantEngage',
  STAGIAIRES = 'stagiaires',
  DATE_DEBUT_DEMANDE = 'dateDebutDemande',
  REFERENCE_OPCOEP = 'referenceOpco',
  NUMERO_FACTURE = 'numeroFacture',
  DATE_DEMANDE = 'dateDemande',
  MONTANT = 'montant',
}